import React, { Fragment } from 'react'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import IconButton from '@mui/material/IconButton';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import BotonDocumentoValidoComponent from './BotonesComponent/BotonDocumentoValidoComponent';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

function DocumentacionInstalacionesComponent(props) {
    let detalleCliente = props?.detalle
    const fc01ConMap = useSelector(store => store.ModuloConsulta.fc01ConMap)
    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')

    let rowsDocumentacionInstalaciones = []
    for (const datos in detalleCliente.anexocliente) {

        rowsDocumentacionInstalaciones.push({ id: uuidv4(), nameDoc: (detalleCliente.anexocliente[datos].tipoanexo.descripcion + ', alias: ' + detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.alias).toUpperCase() })

        let filtro = fc01ConMap?.anexo?.filter(anexo => anexo?.informaciongeneral?.instalacionnumero === detalleCliente?.anexocliente[datos]?.informaciongeneralinstalacioncliente?.instalacionnumero &&
            anexo.informaciongeneral?.alias === detalleCliente?.anexocliente[datos]?.informaciongeneralinstalacioncliente?.alias)
        
        for (const i in detalleCliente.anexocliente[datos].archivosinstalacionescliente) {
            const nameId = detalleCliente.anexocliente[datos].archivosinstalacionescliente[i].nameid
            let nameDoc = ''
            let quitarVigencia = false
            
            if ((nameId).includes('TITULOINS')) nameDoc = 'Copia del título de propiedad a nombre del solicitante'
            else if ((nameId).includes('CAINS')) nameDoc = 'Contrato de arrendamiento'
            else if ((nameId).includes('IOVRINS')) nameDoc = 'Identificación oficial vigente Arrendador'
            else if ((nameId).includes('IOVOINS')) nameDoc = 'Identificación oficial vigente Arrendatario'
            else if ((nameId).includes('CCINS')) nameDoc = 'Contrato comodato'
            else if ((nameId).includes('IOVEINS')) nameDoc = 'Identificación oficial vigente del comodante'

            if (nameId.includes('TITULOINS')) quitarVigencia = true

            let unidad = ''
            if (detalleCliente.anexocliente[datos].tipoanexo.descripcion == 'Unidad de produccion') unidad = 'Unidad de producción'
            if (detalleCliente.anexocliente[datos].tipoanexo.descripcion == 'Unidad de envasado') unidad = 'Unidad de envasado'
            if (detalleCliente.anexocliente[datos].tipoanexo.descripcion == 'Unidad de almacen') unidad = 'Unidad de almacén'
            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento = ''
            if (detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechafin !== null) {

                diasFaltantesVencimiento = moment(detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }

            rowsDocumentacionInstalaciones.push({
                id: uuidv4(),
                observacion: detalleCliente?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.observaciones,
                fechaInicio: detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechainicio !== null ? detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechainicio?.substring(0, 10) : '---',
                fechaTermino: detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechafin !== null ? detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.fechafin?.substring(0, 10) : '---',
                estatus: detalleCliente?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.estatus !== null ? detalleCliente.anexocliente[datos].archivosinstalacionescliente?.[i]?.estatus : 'Agregar',
                tabla: 'archivosinstalacionescliente',
                nombreId: 'idanexocliente',
                idSolicitud: detalleCliente?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.idanexocliente,
                nameid: nameId, nameDoc: nameDoc, /* + ' de la instalación ' + unidad + ': ' + detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.alias, */
                idAnexo: detalleCliente?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.idarchivosinstalacion, colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: quitarVigencia,
                isDocumentoValido: detalleCliente?.anexocliente?.[datos]?.archivosinstalacionescliente?.[i]?.isdocumentovalido
            })
        }
        for (const i in detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {

            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento = ''
            if (detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin !== null) {
                diasFaltantesVencimiento = moment(detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')
                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }
            rowsDocumentacionInstalaciones.push({
                id: uuidv4(),
                observacion: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.observaciones,
                fechaInicio: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechainicio !== null ? detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechainicio?.substring(0, 10) : '---',
                fechaTermino: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin !== null ? detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.fechafin?.substring(0, 10) : '---',
                estatus: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.estatus !== null ? detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.estatus : 'Agregar',
                tabla: 'archivosresposansablescliente',
                nombreId: 'idarchivosresponsables',
                idSolicitud: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.idresponsabledeinstalacioncliente,
                nameid: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.nameid,
                nameDoc: 'Identificación oficial vigente del responsable: ' + detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].nombreresponsable,
                idAnexo: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.idarchivosresponsables,
                colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: false,
                isDocumentoValido: detalleCliente.anexocliente[datos].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[i].archivosresposansablescliente?.[0]?.isdocumentovalido
            })
        }
    }

    const columnsDocumentacion = [
        {
            field: 'documentoValido', headerName: '', headerAlign: 'center', width: 40, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <BotonDocumentoValidoComponent data={params.row} idcliente={detalleCliente.idcliente} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'nameDoc', headerName: '', headerAlign: 'left', width: 430, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla ?
                            <div>
                                <label style={{ width: '100%', textAlign: 'left' }}>{`${params.row.nameDoc}`}</label>
                            </div>
                            :
                            <div style={{ width: '100%', padding: '3%', textAlign: 'left'}}>
                                <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                            </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'fechaTermino', headerName: '', headerAlign: 'center', width: 140, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.quitarVigencia == true &&
                        <Fragment>
                            <label> Sin vigencia </label>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.quitarVigencia == false &&
                        <Fragment>
                            <label> {`${params.row.fechaTermino}`} </label>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            {params.row.tabla == 'archivosresposansablescliente' &&
                                <BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idAnexo} nameid={params.row?.nameid} />
                            }
                            {params.row.tabla == 'archivosinstalacionescliente' &&
                                <BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} />
                            }
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'historial', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'estatusfecha', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.colorAlertaFecha == 'verde' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vigente"><IconButton size="large"> <CheckCircleOutlineRoundedIcon fontSize="inherit" style={{ fill: '#8ABE3E' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'amarillo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Próximo a vencer"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#F4D35E' }} /> </IconButton></Tooltip>                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'rojo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vencido"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#DC3545' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {/*params.row.tabla && params.row.colorAlertaFecha == 'gris' &&
                        <Fragment>
                            <Tooltip title="Sin fechas asignadas"><IconButton size="large"> <BlockRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    */}
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Sustituir archivo">
                                <IconButton size="large" onClick={() => sustituir(params)}> <FileUploadRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton>
                            </Tooltip>
                        </Fragment>
                    }

                </Fragment>
            )
        },
        {
            field: 'observacion', headerName: '', headerAlign: 'center', width: 300, sortable: false
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = {}
        if (params.row.tabla === "archivosgeneralescliente") {
            data = { idSolicitud: params.row.idSolicitud, tabla: params.row.tabla }
        } else {
            data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }
    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }
    return (
        <Fragment >
            <div style={{ fontFamily: 'Montserrat', height: '700px' }}>
                {detalleCliente.anexocliente.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Documentación de instalaciones.</h5>
                        <Box sx={{ height: '700px', width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionInstalaciones}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {detalleCliente.anexocliente.length == 0 &&
                    <div style={{ height: '700px', margin: 0, padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h5 style={{ fontWeight: 'bold', color: '#7D9A47' }} >No existe documentación registrada.</h5>
                    </div>
                }
            </div>
            {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
            {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
        </Fragment>
    )
}

export default DocumentacionInstalacionesComponent